import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from '@/Components/DataTable/DataTable';
import { OrderLabelPrintRow } from '@/Types';
import { useOrderLabelTableColumnInfo } from './ColumnInfo';
import { orderLabelPrintActions, orderLabelPrintModalSelectors } from '../../services';
import styles from './OrderLabelTable.scss';
import { shippingLabelModalActions } from '@/ModalWindows/ShippingLabelModal/services';
import { orderAutomatizationActions } from '@/ModalWindows/OrderAutomatizationModal/services/reducer';
import { ShippingLabelStep } from '@/ModalWindows/ShippingLabelModal/Types';

type Props = {
  selectedOrderIds: number[];
};

function OrderLabelTableComponent({ selectedOrderIds }: Props): React.ReactElement {
  const dispatch = useDispatch();

  const editRowClick = (row: OrderLabelPrintRow): void => {
    const orderIds = selectedOrderIds.filter((x) => x === row.orderId);

    dispatch(shippingLabelModalActions.setIsEditing(true));
    dispatch(orderAutomatizationActions.setSelectedOrders(orderIds));
    dispatch(shippingLabelModalActions.setShippingLabelStep(ShippingLabelStep.OrderWithoutAutomatizaion));
  };

  const columnInfos = useOrderLabelTableColumnInfo(editRowClick);
  const rows = useSelector(orderLabelPrintModalSelectors.orderLabelPrintRows);
  const selectedRowKeys = useSelector(orderLabelPrintModalSelectors.selectedOrderLabelRowKeys);

  return (
    <div className={styles.tableWrapper}>
      <DataTable<OrderLabelPrintRow>
        rows={rows}
        rowKey={'orderId'}
        selectedRowKeys={selectedRowKeys}
        columnInfos={columnInfos}
        className={styles.table}
        filterOptions={{
          needShowFiltersButton: false,
          needHeaderFilter: false,
          needColumnChooser: false,
          showFilterBuilder: false,
        }}
        editOptions={{
          needEditing: false,
        }}
        selectOptions={{
          showCheckBoxesMode: 'onClick',
          onSelectedRowsChanged: (data) => {
            if (data.length > 0) dispatch(orderLabelPrintActions.setSelectedOrderLabelPrints(data));
          },
        }}
      />
    </div>
  );
}

export const OrderLabelTable = React.memo(OrderLabelTableComponent);
